// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sT1_me4ScOkqjyGas1kw{z-index:var(--zIndex-BASE_1);position:absolute;top:24px;left:18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapseButtonContainer": `sT1_me4ScOkqjyGas1kw`
};
export default ___CSS_LOADER_EXPORT___;
